// extracted by mini-css-extract-plugin
export default {"row":"VehicleDetails_row__k9LLQ","form":"VehicleDetails_form__f5uyu"};